export default __webpack_public_path__ + "static/media/Milk2Icecream_05.3f7705b9.png";